<div class="table-responsive table-scroll">
  <table
    id="data-table"
    class="table table-striped table-hover w-100"
    [formGroup]="parentForm"
    aria-label="data-table"
  >
    <thead>
      <tr>
        <th class="text-center w-25" scope="col">Competitor Name<span class="text-danger">*</span></th>
        <th class="text-center w-25" scope="col">Unit Size</th>
        <th class="text-center w-25" scope="col">Distance<span class="text-danger">*</span></th>
        <th class="text-center w-10" *ngIf="!nearByCompetitors.disabled" scope="col">Action</th>
      </tr>
    </thead>
    <tbody formArrayName="nearByCompetitors">
      <tr *ngFor="let tdStore of nearByCompetitors.controls; index as i" [formGroupName]="i">
        <td class="p-1 w-25">
          <ng-select
            name="competitorName"
            placeholder="Please select..."
            [items]="competitorSelectValue"
            [searchable]="false"
            [clearable]="false"
            appendTo=".store-profile-wrapper"
            bindLabel="nameTh"
            bindValue="code"
            formControlName="competitorName"
            (change)="onSelectedCompetitor(i)"
            (open)="disableTableScroll(true)"
            (close)="disableTableScroll(false)"
            [ngClass]="{
              'is-invalid': submitted && tdStore.controls.competitorName.errors
            }"
          ></ng-select>
          <div *ngIf="submitted && tdStore.controls.competitorName.errors" class="invalid-feedback">
            <div *ngIf="tdStore.controls.competitorName.errors.required">
              {{ 'ERRORS.REQUIRED' | translate }}
            </div>
          </div>
        </td>
        <td class="p-1 w-25">
          <ng-select
            name="unitSize"
            placeholder="Please select..."
            [items]="buildingSizeSelectValue"
            [searchable]="false"
            [clearable]="false"
            appendTo=".store-profile-wrapper"
            bindLabel="nameTh"
            bindValue="code"
            formControlName="unitSize"
            (change)="onSelectedCompetitor(i)"
            (open)="disableTableScroll(true)"
            (close)="disableTableScroll(false)"
            [ngClass]="{
              'is-invalid': submitted && tdStore.controls.unitSize.errors
            }"
          ></ng-select>
        </td>
        <td class="p-1 w-25">
          <ng-select
            name="distance"
            placeholder="Please select..."
            [items]="poiDistanceSelectValue"
            [searchable]="false"
            [clearable]="false"
            appendTo=".store-profile-wrapper"
            bindLabel="nameTh"
            bindValue="code"
            formControlName="distance"
            (change)="onSelectedCompetitor(i)"
            (open)="disableTableScroll(true)"
            (close)="disableTableScroll(false)"
            [ngClass]="{
              'is-invalid': submitted && tdStore.controls.distance.errors
            }"
          ></ng-select>
          <div *ngIf="submitted && tdStore.controls.distance.errors" class="invalid-feedback">
            <div *ngIf="tdStore.controls.distance.errors.required">
              {{ 'ERRORS.REQUIRED' | translate }}
            </div>
          </div>
        </td>
        <td class="p-1 w-10 text-center align-middle" *ngIf="!nearByCompetitors.disabled">
          <a class="is-link" (click)="deleteNearByCompetitor(i)">
            <em class="icon-delete" ngxTippy="Delete"></em>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="row">
  <div class="col-md-12">
    <button type="button" id="add" *ngIf="!checkEditPermission()" class="btn btn-standard mt-2" (click)="addForm()">
      <em class="icon-plus"></em>
      Add More
    </button>
  </div>
</div>
